module.exports = __webpack_public_path__ + "5f4a9373be9b7c029c9a24d7afb573c0.svg";